<div class="min-h-screen bg-gray-900 py-8">
  <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
      <div class="flex items-center gap-3">
        <button
          (click)="goBack()"
          class="p-2 rounded-lg bg-gray-800 text-gray-400 hover:text-white hover:bg-gray-700 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div>
          <h1 class="text-3xl font-bold text-white">Categorieën</h1>
          <p class="mt-1 text-sm text-gray-400">Beheer categorieën en subcategorieën voor je berichten</p>
        </div>
      </div>
      <div class="mt-4 sm:mt-0">
        <button
          (click)="showNewCategoryInput = !showNewCategoryInput; newCategoryParentId = null"
          class="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Nieuwe categorie
        </button>
      </div>
    </div>

    <!-- Domain filter -->
    <div class="mb-6" *ngIf="domains.length > 1">
      <select
        [ngModel]="currentDomain"
        (ngModelChange)="onDomainChange($event)"
        class="w-full sm:w-64 rounded-lg bg-gray-800 border-gray-700 text-gray-200 text-sm px-4 py-2.5 focus:ring-indigo-500 focus:border-indigo-500">
        <option *ngFor="let d of domains" [value]="d.name">{{ d.name }}</option>
      </select>
    </div>

    <!-- Nieuwe categorie toevoegen (top-level) -->
    <div *ngIf="showNewCategoryInput" class="mb-6 bg-gray-800 rounded-lg p-4 border border-gray-700 space-y-3">
      <div class="flex items-center gap-3">
        <input
          type="text"
          [(ngModel)]="newCategoryName"
          placeholder="Categorienaam"
          class="flex-1 rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
          autofocus>
        <div class="flex items-center gap-1">
          <span class="text-gray-500 text-xs">/</span>
          <input
            type="text"
            [(ngModel)]="newCategorySlug"
            placeholder="url-slug"
            class="w-32 rounded-lg bg-gray-700 border-gray-600 text-white text-sm px-3 py-2 font-mono focus:ring-indigo-500 focus:border-indigo-500">
        </div>
        <button
          (click)="addCategory()"
          [disabled]="!newCategoryName.trim()"
          class="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Toevoegen
        </button>
        <button
          (click)="showNewCategoryInput = false; newCategoryName = ''; newCategorySlug = ''"
          class="px-3 py-2 text-gray-400 hover:text-white transition-colors">
          Annuleren
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex justify-center py-12">
      <div class="text-gray-400">Categorieën laden...</div>
    </div>

    <!-- Categorieën lijst -->
    <div *ngIf="!loading" class="space-y-2">
      <!-- Lege staat -->
      <div *ngIf="categories.length === 0" class="text-center py-12 bg-gray-800 rounded-lg border border-gray-700">
        <svg class="mx-auto h-12 w-12 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" />
        </svg>
        <p class="mt-3 text-gray-400">Nog geen categorieën</p>
        <button
          (click)="showNewCategoryInput = true"
          class="mt-3 text-indigo-400 hover:text-indigo-300 text-sm font-medium">
          Eerste categorie toevoegen →
        </button>
      </div>

      <!-- Categorie items (recursief via ng-template) -->
      <ng-container *ngFor="let cat of categories">
        <ng-container *ngTemplateOutlet="categoryItem; context: { $implicit: cat, depth: 0 }"></ng-container>
      </ng-container>
    </div>

    <!-- Stats -->
    <div *ngIf="!loading && categories.length > 0" class="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
      <div class="bg-gray-800 rounded-lg p-4 border border-gray-700">
        <p class="text-2xl font-bold text-white">{{ categories.length }}</p>
        <p class="text-xs text-gray-400 mt-1">Hoofdcategorieën</p>
      </div>
      <div class="bg-gray-800 rounded-lg p-4 border border-gray-700">
        <p class="text-2xl font-bold text-white">{{ getTotalSubCount() }}</p>
        <p class="text-xs text-gray-400 mt-1">Subcategorieën</p>
      </div>
      <div class="bg-gray-800 rounded-lg p-4 border border-gray-700">
        <p class="text-2xl font-bold text-white">{{ getTotalPosts() }}</p>
        <p class="text-xs text-gray-400 mt-1">Posts met categorie</p>
      </div>
    </div>
  </div>
</div>

<!-- Recursief template voor categorieën -->
<ng-template #categoryItem let-cat let-depth="depth">
  <div
    class="bg-gray-800 rounded-lg border border-gray-700 transition-all hover:border-gray-600"
    [style.margin-left.px]="depth * 24">

    <div class="flex items-center gap-3 px-4 py-3">
      <!-- Expand/collapse knop (alleen als er children zijn) -->
      <button
        *ngIf="cat.children.length > 0"
        (click)="toggleExpand(cat)"
        class="p-1 text-gray-500 hover:text-gray-300 transition-colors">
        <svg class="w-4 h-4 transition-transform" [class.rotate-90]="cat.expanded" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
      <div *ngIf="cat.children.length === 0" class="w-6"></div>

      <!-- Categorie icoon -->
      <div class="w-8 h-8 rounded-md flex items-center justify-center"
           [class.bg-indigo-600]="depth === 0"
           [class.bg-gray-600]="depth > 0">
        <svg class="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" />
        </svg>
      </div>

      <!-- Naam (weergave of bewerken) -->
      <div class="flex-1 min-w-0" *ngIf="!cat.editing">
        <span class="text-sm font-medium text-gray-200">{{ cat.name }}</span>
        <span *ngIf="cat.slug" class="ml-2 text-xs text-gray-500 font-mono">/{{ cat.slug }}/</span>
      </div>
      <div class="flex-1 min-w-0" *ngIf="cat.editing">
        <input
          type="text"
          [(ngModel)]="cat.editName"
          (keydown.escape)="cancelEdit(cat)"
          placeholder="Naam (standaardtaal)"
          class="w-full rounded-md bg-gray-700 border-gray-600 text-white text-sm px-2 py-1 focus:ring-indigo-500 focus:border-indigo-500 mb-1"
          autofocus>
      </div>

      <!-- Post count badge -->
      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
            [class.bg-indigo-900]="cat.postCount > 0"
            [class.text-indigo-300]="cat.postCount > 0"
            [class.bg-gray-700]="cat.postCount === 0"
            [class.text-gray-400]="cat.postCount === 0">
        {{ cat.postCount }} {{ cat.postCount === 1 ? 'post' : 'posts' }}
      </span>

      <!-- Totaal badge (als er children zijn) -->
      <span *ngIf="cat.children.length > 0"
            class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-700 text-gray-400"
            title="Totaal inclusief subcategorieën">
        Σ {{ getTotalPostCount(cat) }}
      </span>

      <!-- Acties -->
      <div class="flex items-center gap-1" *ngIf="!cat.editing">
        <button
          (click)="startAddSub(cat.id)"
          class="p-1.5 text-gray-500 hover:text-indigo-400 transition-colors rounded-md hover:bg-gray-700"
          title="Subcategorie toevoegen">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
        </button>
        <button
          (click)="startEdit(cat)"
          class="p-1.5 text-gray-500 hover:text-yellow-400 transition-colors rounded-md hover:bg-gray-700"
          title="Hernoemen">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </button>
        <button
          (click)="deleteCategory(cat)"
          class="p-1.5 text-gray-500 hover:text-red-400 transition-colors rounded-md hover:bg-gray-700"
          title="Verwijderen">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>

      <!-- Bewerk acties -->
      <div class="flex items-center gap-1" *ngIf="cat.editing">
        <button
          (click)="saveEdit(cat)"
          class="p-1.5 text-green-400 hover:text-green-300 transition-colors rounded-md hover:bg-gray-700">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </button>
        <button
          (click)="cancelEdit(cat)"
          class="p-1.5 text-gray-400 hover:text-gray-300 transition-colors rounded-md hover:bg-gray-700">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Uitgebreid bewerkpaneel (slug + vertalingen) -->
    <div *ngIf="cat.editing" class="px-4 pb-4 border-t border-gray-700 space-y-3 pt-3">
      <!-- Slug -->
      <div class="flex items-center gap-2 ml-10">
        <label class="text-xs text-gray-400 w-16 flex-shrink-0">URL slug</label>
        <div class="flex items-center gap-1 flex-1">
          <span class="text-gray-500 text-xs">/</span>
          <input
            type="text"
            [(ngModel)]="cat.editSlug"
            placeholder="bijv. producten"
            class="flex-1 rounded-md bg-gray-700 border-gray-600 text-white text-sm px-2 py-1 font-mono focus:ring-indigo-500 focus:border-indigo-500">
          <span class="text-gray-500 text-xs">/post-slug</span>
        </div>
      </div>
      <!-- Vertalingen -->
      <div *ngFor="let lang of availableLanguages" class="flex items-center gap-2 ml-10">
        <label class="text-xs text-gray-400 w-16 flex-shrink-0 uppercase">{{ lang.code }}</label>
        <input
          type="text"
          [ngModel]="cat.editTranslations[lang.code] || ''"
          (ngModelChange)="cat.editTranslations[lang.code] = $event"
          [placeholder]="'Naam in ' + lang.name"
          class="flex-1 rounded-md bg-gray-700 border-gray-600 text-white text-sm px-2 py-1 focus:ring-indigo-500 focus:border-indigo-500">
      </div>
    </div>

    <!-- Subcategorie toevoegen inline -->
    <div *ngIf="addingSubTo === cat.id" class="px-4 pb-3 pt-1 border-t border-gray-700">
      <div class="flex items-center gap-2 ml-10">
        <input
          type="text"
          [(ngModel)]="newSubCategoryName"
          (keydown.enter)="addSubCategory(cat.id)"
          (keydown.escape)="cancelAddSub()"
          placeholder="Naam subcategorie"
          class="flex-1 rounded-md bg-gray-700 border-gray-600 text-white text-sm px-3 py-1.5 focus:ring-indigo-500 focus:border-indigo-500"
          autofocus>
        <button
          (click)="addSubCategory(cat.id)"
          [disabled]="!newSubCategoryName.trim()"
          class="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-medium rounded-md transition-colors disabled:opacity-50">
          Toevoegen
        </button>
        <button
          (click)="cancelAddSub()"
          class="px-2 py-1.5 text-gray-400 hover:text-white text-xs transition-colors">
          Annuleren
        </button>
      </div>
    </div>
  </div>

  <!-- Children (recursief) -->
  <ng-container *ngIf="cat.expanded && cat.children.length > 0">
    <ng-container *ngFor="let child of cat.children">
      <ng-container *ngTemplateOutlet="categoryItem; context: { $implicit: child, depth: depth + 1 }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<app-notification></app-notification>
